module.exports = __webpack_public_path__ + "img/chart_meter.ebb66a0c.svg";